<template>
	<div class="basis-page-cls">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
		<section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
                <div class="btns">
                    <el-button @click.stop="handleCreate" type="primary" size="small" icon="el-icon-circle-plus-outline" class="right">新增</el-button>
                </div>
            </div>
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize"
                    @pagination="getList">
					<template v-slot:brand="{ row }">
						<span v-for="(val, index) in row.brand.split(',')" :key="index">
							{{(config_data['brands'].filter(item => item.code === val).length > 0) ? (config_data['brands'].filter(item => item.code === val)[0]['name']) : val}}
						</span>
					</template>
						<template v-slot:supplier="{ row }">
						<span>{{config_data['suppliers'].filter(item => item.code === row.supplier).length > 0 ? config_data['suppliers'].filter(item => item.code === row.supplier)[0]['name'] : row.supplier}}</span>
					</template>
				</table-pagination>
            </div>
        </section>

		<el-drawer 
            :title="dialog_status == 'create' ? '新增' : dialog_status == 'update' ? '修改' : '详情'" 
            :visible.sync="dialog_visible_touch_in"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="600px"
            direction="rtl">
            <el-form :model="template_form" ref="template_form" labelPosition="right" autoComplete="on" labelWidth="120px">
				<el-form-item prop="subbrandId" label="品牌：">
                    <el-select v-model="template_form.subbrandId" :disabled="dialog_status == 'info'" placeholder="请选择品牌" style="width:450px;" multiple collapse-tags>
                        <el-option v-for="item in config_data['brands']" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item prop="name" label="模板名称：" :rules="[{required: true, trigger: 'blur', message: '请输入模板名称'}]">
                    <el-input v-model="template_form.name" :disabled="dialog_status == 'info'" placeholder="请输入模板名称" style="width:450px;" maxlength="50" show-word-limit clearable></el-input>
                </el-form-item>
				<el-form-item prop="templetBody" label="模板正文：" :rules="[{required: true, trigger: 'blur', message: '请输入模板正文'}]">
                    <el-input id="textarea" v-model="template_form.templetBody" ref="singleText" :rows="4" type="textarea" :disabled="dialog_status == 'info'" placeholder="请输入模板正文" style="width:450px;" clearable></el-input>
					<el-button @click.stop="insert('$$客户名称$$')" icon="el-icon-circle-plus-outline" type="text" size="mini">动态参数：客户名称</el-button>
				</el-form-item>
				<el-divider v-if="dialog_status !== 'info'"></el-divider>
                <el-form-item  v-if="dialog_status !== 'info'" style="float: right;padding-right: 30px;">
                    <el-button @click="dialog_visible_touch_in = false">取 消</el-button>
                    <el-button @click.stop="handelSubmit" :loading="loading" type="primary">保 存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
	</div>
</template>

<script>
import Vue from 'vue';
import { tableMixin } from "utils/mixins";
export default {
	mixins: [tableMixin],
	data() {
		const formatDate = Vue.filter('formatDate');
		return {
			column: [
				{
					label: '序号',
					width: 50,
					align: 'center',
					render: (h, scope) => {
						return (
							<span>{((this.listQuery.pageNum - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
						)
					}
				},
				{label: '模板名称', prop: 'name'},
				{
					label: '创建时间', 
					render: (h, scope) => {
						return (
							<span>{formatDate(scope.row.createTime)}</span>
						)
					}
				},
				{label: '模板正文', prop: 'templetBody'},
				{
                    label: '操作',
                    prop: 'cation',
                    width: 100,
                    fixed: 'right',
					align: 'center',
                    render: (h, scope) => {
						return (
							<div>
								<el-link onClick={() => this.handelEdit(scope.row)} type="primary" underline={false}>修改</el-link>
								<el-divider direction="vertical"></el-divider>
								<el-link onClick={() => this.handleDelete(scope.row)} type="danger" underline={false}>删除</el-link>
							</div>
						)
                    }
                }
			],
			filterHeader: [
				{ label: '品牌', model: 'subbrandId', type: 'select', default: '', list: [] },
				{ label: '模板名称', model: 'name', type: 'input', default: '', placeholder: '请输入模板名称' },
			],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				subbrandId: '',
				name: ''
			},
			list: [],
			total: 0,
			config_data: {
				brands: [],
				suppliers: []
			},
			loading: false,
			dialog_visible_touch_in: false,
			dialog_status: 'create',
			template_form: {
				subbrandId: [],
				name: '',
				templetBody: '',
			}
		}
	},
	async created() {
		await this.getList();
		await this.getConfigData();
	},
	methods: {
		async insert(myValue) {
			const myField = document.querySelector('#textarea');
			if(myField.selectionStart || myField.selectionStart === 0) {
				let startPos = myField.selectionStart;
				let endPos = myField.selectionEnd;
				this.template_form.templetBody = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length);
				await this.$nextTick();
				myField.focus();
				myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length);
			} else {
				this.template_form.templetBody += myValue;
			}
		},
		getList() {
			this.$api.apiPostSmsTemplateList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response['list'];
				this.total = response.total;
			});
		},
		handleCreate() {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'create';
		},
		handelEdit(row) {
			this.resetForm();
			this.dialog_visible_touch_in = true;
			this.dialog_status = 'update';
			this.template_form = Object.assign(this.template_form, row);
			this.template_form['subbrandId'] = this.template_form['brand'].split(',');
		},
		handleDelete(row) {
			this.$confirm('删除后，该账户无法正常使用，账户下的发送信息数据将会消失。是否继续?', '系统提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.apiPostSmsTemplateDelete({templetId: row.templetId}).then(response => {
					if(response.errcode != 0) return;
					this.$notify({
						title: "删除成功",
						offset: 70,
						type: "success"
					});
					this.getList();
				});
			}).catch(() => {});
		},
		handelSubmit() {
            this.$refs["template_form"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.$api.apiPostSmsTemplateTouchIn(this.template_form).then(response => {
						if(response.errcode != 0) return;
                        this.$notify({
                            title: "保存成功",
                            offset: 70,
                            type: "success"
                        });
                        this.dialog_visible_touch_in = false;
						this.loading = false;
                        this.getList();
                    }).catch(error => {
						this.loading = false;
					});
                }
            });
		},
		resetForm() {
			this.template_form = {
				subbrandId: [],
				name: '',
				templetBody: '',
			}
			if (this.$refs["template_form"]) {
				this.$refs["template_form"].clearValidate();
			}
		},
		getConfigData() {
			this.filterHeader[0]['list'] = [];
			this.$api.apiPostSmsConfigData(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.config_data = Object.assign(this.config_data, response.data);
				for(const item of this.config_data['brands']) {
					this.filterHeader[0]['list'].push({
						id: item.code,
						name: item.name
					});
				}
			});
		},
		filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList();
		}
	}
}
</script>
